export const ACTIONS_MACHINE_CLASS = {
  INVALIDATE: 'MACHINE_CLASSES_INVALIDATE',
  RECEIVE: 'MACHINE_CLASSES_RECEIVE',
  DELETE: 'MACHINE_CLASS_DELETE',
  UPDATE: 'MACHINE_CLASS_UPDATE',
};

const machineClassConstants = {};

export default machineClassConstants;
